import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import AppChip from '../../../components/chips/AppChip'
import {
  UI_COLOR_DANGER,
  UI_COLOR_DANGER_SOFT,
  UI_COLOR_SUCCESS,
  UI_COLOR_SUCCESS_SOFT
} from '../../../constants/uiColors'
import { rbacAssignedUserChipSx } from '../constants/rbacAssignedDataDetailConstants'
import {
  auditFieldLabelSx,
  auditMutedTextSx,
  auditSummaryTextSx
} from './rbacAuditHistoryConstants'

export default function RbacAuditAppUserAssignments({ detail }) {
  const [expanded, setExpanded] = useState(false)
  const count = detail.groups.reduce((total, group) => total + group.items.length, 0)
  const collapsible = count > 3
  const showItems = !collapsible || expanded

  return (
    <Box>
      <Typography sx={auditSummaryTextSx}>{detail.summary}</Typography>
      {showItems &&
        detail.groups.map((group) => (
          <Box key={group.kind} sx={{ mt: 1 }}>
            <Typography sx={{ ...auditFieldLabelSx, fontSize: 12, mb: 0.5 }}>
              {group.label}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
              {group.items.map((item) => (
                <AppChip
                  key={item.uid}
                  renderAs="span"
                  label={item.name ? `${item.uid} - ${item.name}` : item.uid}
                  sx={{
                    ...rbacAssignedUserChipSx,
                    ...(group.kind === 'added'
                      ? {
                          backgroundColor: UI_COLOR_SUCCESS_SOFT,
                          color: UI_COLOR_SUCCESS
                        }
                      : {}),
                    ...(group.kind === 'removed'
                      ? {
                          backgroundColor: UI_COLOR_DANGER_SOFT,
                          color: UI_COLOR_DANGER,
                          textDecoration: 'line-through'
                        }
                      : {})
                  }}
                />
              ))}
            </Box>
          </Box>
        ))}
      {collapsible && (
        <Button
          size="small"
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
          sx={{ p: 0, mt: 0.75, minWidth: 0, textTransform: 'none' }}
        >
          {expanded ? 'Ver menos' : `Ver cambios (${count})`}
        </Button>
      )}
      {detail.showCurrentAccess && (
        <Typography sx={{ ...auditMutedTextSx, mt: 0.75, fontSize: 12 }}>
          {detail.currentAccess}
        </Typography>
      )}
    </Box>
  )
}
